import * as moment from "moment";
import Excel from "exceljs";
import FileSaver from "file-saver";

let MethodService = {};

// roles: ["AdminSystem","Customer"]
MethodService.checkRole = function (stringRoles) {
  var currentUser = JSON.parse(window.localStorage.currentUser);
  let roles = stringRoles.split(",");
  var flag = false;
  roles.forEach(function (item) {
    item = item.trim();
    if (currentUser.roles.indexOf(item) != -1) {
      flag = true;
    }
  });
  return flag;
};

MethodService.getCurrentUser = function () {
  return JSON.parse(window.localStorage.currentUser);
};
MethodService.getCompanyInfo = function () {
  return JSON.parse(window.localStorage.companyInfo);
};

//required iso 9001 ex: yyyy-dd-mmThh:mm:ssZ
let formatDateMonth = "MM/YYYY";
let formatDateMoment = "DD/MM/YYYY";
let formatMomentDate = "YYYY-MM-DD";

//ex: iso date to string date  yyyy-dd-mmThh:mm:ssZ - > DD/MM/YYYY
//ex: new Date to iso date  Wed Mar 25 2015 07:00:00 GMT+0700 (Giờ Đông Dương) - > yyyy-dd-mmThh:mm:ssZ || MethodService.formatDate(new Date, "")
MethodService.formatDate = function (value, rule) {
  if (value) {
    var format = "";
    if (rule == "date") {
      format = formatDateMoment;
    } else if (rule == "datetime") {
      format = formatDateMoment + " HH:mm";
    } else if (rule == "aboutTime") {
      format = formatDateMoment + " HH:mm";
    } else if (rule == "month") {
      format = formatDateMonth;
    } else if (rule == "year") {
      format = formatMomentDate;
    } else {
      format = rule;
    }
    return moment(value).format(format);
  } else {
    return "";
  }
};

MethodService.formatTimestamp = function (value, rule) {
  if (value) {
    var format = "";
    if (rule == "date") {
      format = formatDateMoment;
    } else if (rule == "datetime") {
      format = formatDateMoment + " HH:mm";
    } else if (rule == "aboutTime") {
      format = formatDateMoment + " HH:mm";
    } else {
      format = rule;
    }
    return moment(value, "YYYY:MM:DDTHH:mm:ss.SSSZZ").format(format);
  } else {
    return "";
  }
};

MethodService.getAboutTime = function (value) {
  if (value) {
    let timeAgo = moment(value).fromNow();
    timeAgo = timeAgo
      .replace("a few seconds ago", "vài giây trước")
      .replace("minutes ago", "phút trước")
      .replace("hours ago", "giờ trước");
    return timeAgo;
  } else {
    return "";
  }
};

MethodService.addDate = function (value, type, numberTime) {
  if (!value) {
    return "";
  }
  return moment(value).add(numberTime, type).format("YYYY-MM-DDTHH:mm:ss");
};

MethodService.formatterTrimString = function (
  row,
  column,
  cellValue,
  index,
  number
) {
  if (!number) {
    number = 8;
  }
  var lengthAllow = (column.width ? column.width : column.realWidth) / number;
  if (cellValue) {
    if (cellValue.length > lengthAllow) {
      return cellValue.slice(0, lengthAllow) + "...";
    } else {
      return cellValue;
    }
  } else {
    return "";
  }
};

MethodService.formatterFloatNumber = function (row, column, cellValue, index) {
  if (cellValue) {
    cellValue = parseFloat(cellValue).toFixed(2);
    return cellValue.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
  }
};

MethodService.stringToObject = function (value) {
  var obj = {};
  if (!value) return obj;

  value.split("&").forEach((frm) => {
    var m = decodeURIComponent(frm).match(
      /^(\w+(\.\w+)*)(=|>=|<=|<>|!=|:\w+:)(.*)/
    );
    if (!m) return;
    if (m[1] in obj) return;
    if (m[3].match(/:regex(_\w+)?:/)) obj[m[1]] = unescapeRegex(m[4]);
    else obj[m[1]] = m[4];
  });

  return obj;
};

MethodService.CalculationYear = function (type, last, next) {
  var toGo = "";
  var yearNow = new Date();
  var limit = yearNow.getFullYear();
  if (type == "last") {
    toGo = last;
  }
  if (type == "next") {
    toGo = next;
    limit = limit + next - 1;
  }
  if (type == "last-next") {
    toGo = next + last;
    limit = limit + next - 1;
  }
  var arr = [];
  for (let i = 0; i < toGo; i++) {
    arr.push(limit - i);
  }
  return arr;
};

MethodService.beforeAvatarUpload = function (file, mb) {
  return file.size / 1024 / 1024 < mb;
};

MethodService.EndYearBind = function (startYear) {
  let arr = [];
  let setYear = new Date();
  let yearPresent = setYear.getFullYear();

  if (startYear) {
    let rangToYearStart = yearPresent - startYear;
    if (rangToYearStart <= 20) {
      for (let i = rangToYearStart; i >= 1; i--) {
        arr.push(startYear + i);
      }
    } else {
      for (let i = 20; i <= 1; i) {
        arr.push(startYear + i);
      }
    }
  } else {
    for (let i = 0; i < 20; i++) {
      arr.push(yearPresent - i);
    }
  }

  return arr;
};

MethodService.StartYearBind = function (endYear) {
  let arr = [];
  let setYear = new Date();
  let yearPresent = setYear.getFullYear();
  if (endYear) {
    let rangToYearStart = endYear - Number(2000);
    if (rangToYearStart <= 20)
      for (let i = 1; i < rangToYearStart; i++) {
        arr.push(endYear - i);
      }
  } else {
    for (let i = 1; i < 20; i++) {
      arr.push(yearPresent - i);
    }
  }
  return arr;
};

MethodService.stopLadda = function () {
  setTimeout(function () {
    Ladda.stopAll();
  }, 100);
};

MethodService.checkFileSize = function (file, mb) {
  return file.size / 1024 / 1024 < mb;
};

MethodService.checkFileType = function (type) {
  let typeFile = ["mp4", "jpg", "png", "jpeg", "mp4", "avi", "mov"];
  return typeFile.includes(type);
};

MethodService.isString = function (value) {
  return typeof value === "string" || value instanceof String;
};

MethodService.isNumber = function (value) {
  return typeof value === "number" && isFinite(value);
};

MethodService.isArray = function (value) {
  return value && typeof value === "object" && value.constructor === Array;
};

MethodService.isFunction = function (value) {
  return typeof value === "function";
};

MethodService.isObject = function (value) {
  return value && typeof value === "object" && value.constructor === Object;
};

MethodService.isDate = function (value) {
  return value instanceof Date;
};

MethodService.isBoolean = function (value) {
  return typeof value === "boolean";
};

MethodService.isNull = function (value) {
  return value === null;
};

MethodService.isUndefined = function (value) {
  return typeof value === "undefined";
};

MethodService.checkIsDate = function (day, month, year) {
  var d = parseInt(day);
  var m = parseInt(month);
  var y = parseInt(year);

  var date = new Date(y, m - 1, d);
  return (
    date.getFullYear() == y && date.getMonth() + 1 == m && date.getDate() == d
  );
};

MethodService.copyObject = function (value) {
  return JSON.parse(JSON.stringify(value));
};

// so sánh 2 object khởi tạo và object trả về, nếu trả về thiếu trường thì lấy trường từ object khởi tạo gán vào objetc trả về
MethodService.checkDifferentObject = function (objectOld, objectNew) {
  function forObject(objectOld) {
    $.each(objectOld, function (key_objectOld, value_objectOld) {
      if (MethodService.isUndefined(objectNew[key_objectOld])) {
        objectNew[key_objectOld] = objectOld[key_objectOld];
      } else if (MethodService.isNull(objectNew[key_objectOld])) {
        objectNew[key_objectOld] = objectOld[key_objectOld];
      } else {
        if (MethodService.isObject(value_objectOld)) {
          forObject(value_objectOld);
        }
      }
    });
  }
  forObject(objectOld);
  return objectNew;
};

MethodService.formatCurrencyVND = (value) =>
  new Intl.NumberFormat("vi-VN", { style: "currency", currency: "VND" }).format(
    value
  );

MethodService.capitalizeFirstLetter = (value) =>
  value.charAt(0).toUpperCase() + value.slice(1);

const defaultNumbers = " hai ba bốn năm sáu bảy tám chín";

const chuHangDonVi = `1 một${defaultNumbers}`.split(" ");
const chuHangChuc = `lẻ mười${defaultNumbers}`.split(" ");
const chuHangTram = `không một${defaultNumbers}`.split(" ");

function convert_block_two(monney) {
  let dv = chuHangDonVi[monney[1]];
  const chuc = chuHangChuc[monney[0]];
  let append = "";

  // Nếu chữ số hàng đơn vị là 5
  if (monney[0] > 0 && parseInt(monney[1]) === 5) {
    dv = "lăm";
  }
  // Nếu số hàng chục lớn hơn 1
  if (monney[0] > 1) {
    append = " mươi";
    if (parseInt(monney[1]) === 1) {
      dv = " mốt";
    }
  }
  return `${chuc}${append} ${dv}`;
}

function convert_block_three(monney) {
  if (monney === "000") return "";
  const a = `${monney}`; // Convert biến 'number' thành kiểu string
  // Kiểm tra độ dài của khối
  switch (a.length) {
    case 0:
      return "";
    case 1:
      return chuHangDonVi[a];
    case 2:
      return convert_block_two(a);
    case 3:
      let chucDv = "";
      if (a.slice(1, 3) !== "00") chucDv = convert_block_two(a.slice(1, 3));
      const tram = `${chuHangTram[a[0]]} trăm`;
      return `${tram} ${chucDv}`;
    default:
      break;
  }
}

const dvBlock = "1 nghìn triệu tỷ".split(" ");
MethodService.toVietnamese = (monney) => {
  if (monney === 0) return "Không đồng";
  const str = `${parseInt(monney)}`;
  let i = 0;
  const arr = [];
  let index = str.length;
  const result = [];
  let rsString = "";

  if (index === 0 || str === "NaN") return "";
  // Chia chuỗi số thành một mảng từng khối có 3 chữ số
  while (index >= 0) {
    arr.push(str.substring(index, Math.max(index - 3, 0)));
    index -= 3;
  }
  // Lặp từng khối trong mảng trên và convert từng khối đấy ra chữ Việt Nam
  for (i = arr.length - 1; i >= 0; i--) {
    if (arr[i] !== "" && arr[i] !== "000") {
      // console.log('arr[i]', arr[i]);
      // console.log('convert_block_three(arr[i])', convert_block_three(arr[i]));
      result.push(convert_block_three(arr[i]));
      // Thêm đuôi của mỗi khối
      if (dvBlock[i]) {
        result.push(dvBlock[i]);
      }
    }
  }
  // Join mảng kết quả lại thành chuỗi string
  rsString = `${result.join(" ")} đồng`;
  // Trả về kết quả kèm xóa những ký tự thừa
  return rsString.replace(/[0-9]/g, "").replace(/ /g, " ").replace(/ $/, "");
};

// Tìm các phần tử khác nhau có trong mảng object trả về [],
// nếu truyền [object] thì truyển thêm field
// nếu truyền array thì k cần
MethodService.findListItemDifferent = function (arrItem, field) {
  let arrItemNew = [];
  if (field) {
    $.each(arrItem, (index, item) => {
      if (item[field]) {
        if (arrItemNew.indexOf(item[field]) == -1) {
          arrItemNew.push(item[field]);
        }
      }
    });
    return arrItemNew;
  } else {
    return arrItem.filter((item, index) => {
      return arrItem.indexOf(item) === index;
    });
  }
};

MethodService.findListItemDuplicate = function (arrItem1, arrItem2) {
  return arrItem1.filter(function (val) {
    return arrItem2.indexOf(val) != -1;
  });
};

MethodService.replaceURLImage = function (value) {
  return value.replace(
    /(!\[[^\]]*\])\([\w.\-\/:]+file\/thumb\?id=([0-9a-fA-F]{24})\)/g,
    "$1($2)"
  );
};

MethodService.checkSDT = function (value) {
  return RegExp(/^(0|\+?84|0084)\d{9}$/).test(value);
};

MethodService.toIsoDate = function (value) {
  return moment(value).format("YYYY-MM-DDTHH:mm:ss.SSSZZ");
};

function escapeRegex(string) {
  return string.toString().replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
}

function unescapeRegex(string) {
  return string.toString().replace(/\\([-\/\\^$*+?.()|[\]{}])/g, "$1");
}

MethodService.filterTable = function (jsonFilter) {
  if (jsonFilter) {
    let dataSearch = JSON.parse(jsonFilter);
    let filters = "";
    $.each(dataSearch.value, (key, value) => {
      if (value) {
        if (dataSearch.operator[key]) {
          let operator = dataSearch.operator[key];
          if (operator == "<+1day") {
            filters +=
              key +
              "<" +
              encodeURIComponent(
                encodeURIComponent(MethodService.addDate(value, "days", 1))
              ) +
              "&";
          } else if (operator == "$vn_text=") {
            filters += operator + encodeURIComponent(value) + "&";
          } else if (operator == ":in_that_day:") {
            filters +=
              key +
              ">=" +
              encodeURIComponent(MethodService.toIsoDate(value[0])) +
              "&" +
              key +
              "<" +
              encodeURIComponent(
                MethodService.toIsoDate(
                  MethodService.addDate(value[1], "days", 1)
                )
              ) +
              "&";
          } else if (operator.match(/^:regex(_\w+)?:$/)) {
            filters +=
              key + operator + encodeURIComponent(escapeRegex(value)) + "&";
          } else {
            filters += key + operator + encodeURIComponent(value) + "&";
          }
        } else {
          filters += key + "=" + encodeURIComponent(value) + "&";
        }
      }
    });
    return filters.slice(0, -1);
  } else {
    return "";
  }
};

MethodService.changeAlias = function (alias) {
  var str = alias.toLowerCase();
  str = str.toLowerCase();
  str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
  str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
  str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i");
  str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
  str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
  str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
  str = str.replace(/đ/g, "d");
  str = str.replace(
    /!|@|%|\^|\*|\(|\)|\+|\=|\<|\>|\?|\/|,|\.|\:|\;|\'|\"|\&|\#|\[|\]|~|\$|_|`|-|{|}|\||\\/g,
    " "
  );
  str = str.replace(/ + /g, " ");
  str = str.trim();
  return str;
};

MethodService.getAge = function (year, month, day) {
  let today = new Date();
  let birthDate = new Date(year, month - 1, day);
  let age = today.getFullYear() - birthDate.getFullYear();
  let m = today.getMonth() - birthDate.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }
  return age;
};

MethodService.changeNumberToString = (number) => {
  if (MethodService.isNumber(number)) {
    if (number >= 1000000000) {
      return Math.floor(number / 1000) + "B";
    } else if (number >= 1000000) {
      return Math.floor(number / 1000000) + "M";
    } else if (number >= 1000) {
      return Math.floor(number / 1000000000) + "N";
    } else {
      return number;
    }
  } else {
    return number;
  }
};

MethodService.markdownOption = {
  previewStyle: "vertical", //tab | vertical
  mode: "markdown",
  options: {
    minHeight: "200px",
    language: "vi_VN",
    useCommandShortcut: true,
    useDefaultHTMLSanitizer: true,
    usageStatistics: false,
    hideModeSwitch: true,
    placeholder: "Nhập nội dung...",
    toolbarItems: [
      "heading",
      "bold",
      "italic",
      "strike",
      "divider",
      "hr",
      "quote",
      "divider",
      "ul",
      "ol",
      "task",
      "indent",
      "outdent",
      "divider",
      "table",
      // 'image',
      "link",
      "divider",
      "code",
      // 'codeblock'
    ],
  },
};

// vucodiing add
MethodService.markdownModel = {
  dialogImage: false,
  dialogImageTab: "insert",
  dataFormImage: {
    title: null,
    link: null,
    file: null,
  },
  validFormImage: {
    title: [],
    link: [],
    file: [],
  },
};

MethodService.element = {
  datepicker: {
    formatDate: "dd/MM/yyyy",
    formatDatetime: "dd/MM/yyyy HH:mm",
    valueFormat: "yyyy-MM-ddTHH:mm:ss",
    placeholderDate: "Ngày/Tháng/Năm",
    placeholderDatetime: "Ngày/Tháng/Năm Giờ:Phút",

    formatMonth: "MM/yyyy",
    placeholderMonth: "Tháng/Năm",
    formatYear: "yyyy",
    placeholderYear: "Năm",
  },
};
//Đổi số điện thoại
MethodService.formatPhone = function (value) {
  if (!/^(0|\+?84|0084)\d{9}$/.test(value)) return value;
  return "0" + value.slice(-9);
};
// Đổi số điện thoại về đâu 0
MethodService.formatPhoneRemove84 = function (value) {
  if (value.slice(0, 2) !== "84") return value;
  return "0" + value.slice(2);
};
// Đổi số điện thoại về đầu 84
MethodService.formatPhone84 = function (value) {
  if (value.slice(0, 1) !== "0") return value;
  return "84" + value.slice(-9);
};
MethodService.formatPhone84DiDong_CoDinh = function (value) {
  if (value.slice(0, 1) !== "0") return value;
  return "84" + value.slice(1);
};

//Đổi số điện thoại ver.2
MethodService.changePhone = function (value) {
  if (value.slice(0, 2) !== "84") return value;
  return "0" + value.slice(2, 11);
};

// đổi số sang  đơn vị tiền tệ
// MethodService.formatPrice = function (value) {
//   return value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
// };

MethodService.numberToVND = (n) => {
  var string = n.toString(),
    units,
    tens,
    scales,
    start,
    end,
    chunks,
    chunksLen,
    chunk,
    ints,
    i,
    word,
    words,
    and = "and";

  /* Remove spaces and commas */
  string = string.replace(/[, ]/g, "");

  /* Is number zero? */
  if (parseInt(string) === 0) {
    return "zero";
  }

  /* Array of units as words */
  units = [
    "",
    "Một",
    "Hai",
    "Ba",
    "Bốn",
    "Năm",
    "Sáu",
    "Bẩy",
    "Tám",
    "Chín",
    "Mười",
    "Mười một",
    "Mười hai",
    "Mười ba",
    "Mười bốn",
    "Mười năm",
    "Mười sáu",
    "Mười bẩy",
    "Mười tám",
    "Mười chín",
  ];

  /* Array of tens as words */
  tens = [
    "",
    "",
    "Hai mươi",
    "Ba mươi",
    "Bốn mươi",
    "Năm mươi",
    "Sáu mươi",
    "Bảy mươi",
    "Tám mươi",
    "Chín mươi",
  ];

  /* Array of scales as words */
  scales = [
    "",
    "nghìn",
    "triệu",
    "tỷ",
    "nghìn tỷ",
    "triệu tỷ",
    "quintillion",
    "sextillion",
    "septillion",
    "octillion",
    "nonillion",
    "decillion",
    "undecillion",
    "duodecillion",
    "tredecillion",
    "quatttuor-decillion",
    "quindecillion",
    "sexdecillion",
    "septen-decillion",
    "octodecillion",
    "novemdecillion",
    "vigintillion",
    "centillion",
  ];

  /* Split user argument into 3 digit chunks from right to left */
  start = string.length;
  chunks = [];
  while (start > 0) {
    end = start;
    chunks.push(string.slice((start = Math.max(0, start - 3)), end));
  }

  /* Check if function has enough scale words to be able to stringify the user argument */
  chunksLen = chunks.length;
  if (chunksLen > scales.length) {
    return "";
  }

  /* Stringify each integer in each chunk */
  words = [];
  for (i = 0; i < chunksLen; i++) {
    chunk = parseInt(chunks[i]);

    if (chunk) {
      /* Split chunk into array of individual integers */
      ints = chunks[i].split("").reverse().map(parseFloat);

      /* If tens integer is 1, i.e. 10, then add 10 to units integer */
      if (ints[1] === 1) {
        ints[0] += 10;
      }

      /* Add scale word if chunk is not zero and array item exists */
      if ((word = scales[i])) {
        words.push(word);
      }

      /* Add unit word if array item exists */
      if ((word = units[ints[0]])) {
        words.push(word);
      }

      /* Add tens word if array item exists */
      if ((word = tens[ints[1]])) {
        words.push(word);
      }

      /* Add 'and' string after units or tens integer if: */
      if (ints[0] || ints[1]) {
        /* Chunk has a hundreds integer or chunk is the first of multiple chunks */
        if (ints[2] || (!i && chunksLen)) {
          words.push(and);
        }
      }

      /* Add hundreds word if array item exists */
      if ((word = units[ints[2]])) {
        words.push(word + " trăm"); // hundred
      }
    }
  }

  return words.reverse().join(" ");
};

MethodService.exportExcel = function (dataList, idDongHo, tenDongHo) {
  let workbook = new Excel.Workbook();
  workbook.created = new Date();
  workbook.calcProperties.fullCalcOnLoad = false;
  workbook.views = [
    {
      x: 0,
      y: 0,
      width: 10000,
      height: 20000,
      firstSheet: 0,
      activeTab: 0,
      visibility: "visible",
    },
  ];

  //Tạo sheet DS thành viên
  let worksheet = workbook.addWorksheet("DS Thành viên", {
    views: [{ state: "frozen", xSplit: 1, ySplit: 1 }],
  });

  worksheet.columns = [
    { header: "STT", key: "stt", width: 8 },
    { header: "ID", key: "id", width: 30 },
    { header: "Kích hoạt", key: "kich_hoat", width: 10 },
    { header: "Đời", key: "doi", width: 8 },
    { header: "Họ và tên", key: "ho_ten", width: 25 },
    { header: "Tên cha/mẹ", key: "cha_me_ten", width: 25 },
    { header: "Giới tính", key: "gioi_tinh", width: 15 },
    { header: "Ngày sinh", key: "ngay_sinh", width: 30 },
    { header: "Ngày mất", key: "ngay_mat", width: 30 },
    { header: "Trong họ", key: "trong_ho", width: 10 },
    { header: "Ngày tạo", key: "ngay_tao", width: 25 },
    { header: "Người tạo", key: "nguoi_tao", width: 25 },
    { header: "Ngày cập nhật", key: "ngay_cap_nhat", width: 20 },
    { header: "Người cập nhật", key: "nguoi_cap_nhat", width: 25 },
    { header: "Ngày kích hoạt", key: "ngay_kich_hoat", width: 25 },
    { header: "Ngày duyệt", key: "ngay_duyet", width: 25 },
    { header: "Quyền hạn", key: "quyen_han", width: 20 },
  ];

  let row = worksheet.getRow(1);
  row.eachCell(function (cell, colNumber) {
    row.getCell(colNumber).font = { bold: true };
    row.getCell(colNumber).alignment = {
      vertical: "middle",
      horizontal: "center",
    };
  });

  $.each(dataList, (index, element) => {
    let item = {};
    item.stt = index + 1;
    item.id = element.id;
    item.kich_hoat = element.kich_hoat;
    item.doi = element.so_doi;
    item.ho_ten = element.ten.ho_ten;
    item.cha_me_ten = element.cha_me_1_ten;
    item.gioi_tinh = element.gioi_tinh;
    item.ngay_sinh = element.sinh ? element.sinh.ngay_sinh : "";
    item.ngay_mat = element.mat ? element.mat.ngay_mat : "";
    item.trong_ho = element.trong_ho;
    item.ngay_tao = element.thoi_diem_tao;
    item.nguoi_tao = element.nguoi_tao_id;
    item.ngay_cap_nhat = element.thoi_diem_cap_nhat;
    item.nguoi_cap_nhat = element.nguoi_cap_nhat_id;
    item.ngay_kich_hoat = element.thoi_diem_kich_hoat; // chờ api
    item.ngay_duyet = element.thoi_diem_duyet; // chờ api
    if (element.role === "FamilyAdmin") {
      item.quyen_han = "Trưởng họ";
    } else if (element.role === "FamilyModerator") {
      item.quyen_han = "Ban quản lý";
    } else item.quyen_han = "Thành viên";

    worksheet.addRow(item);
  });

  worksheet.getRow(1).height = 20;
  worksheet.eachRow({ includeEmpty: true }, (row, rowNumber) => {
    row.eachCell(function (cell, colNumber) {
      if (rowNumber == 1) {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "9e1c1e" },
        };
        cell.font = {
          color: { argb: "FFFFFF" },
          bold: true,
        };
        cell.alignment = {
          vertical: "middle",
          horizontal: "center",
          wrapText: true,
        };
      } else {
        cell.alignment = {
          vertical: "middle",
          wrapText: true,
        };
      }
      // Set border of each cell
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };
    });
  });

  workbook.xlsx.writeBuffer().then(function (data) {
    var blob = new Blob([data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    FileSaver.saveAs(blob, `DsTvDH-${idDongHo}-${tenDongHo}.xlsx`);
  });
};

MethodService.showError = (maCode) => {
  setTimeout(function () {
    Ladda.stopAll();
  }, 100);
  switch (maCode) {
    case 4:
      window.toastr.error("Mất kết nối với Server");
      break;
    case 2:
      window.toastr.error("Máy chủ không phản hồi");
      break;
    default:
      window.toastr.error("Đã có lỗi xảy ra");
  }
};

// bấm sắp xếp bảng
MethodService.tableSortChange = (column, tableRules) => {
  column.order == "ascending"
    ? (tableRules.sort = column.prop)
    : column.order == "descending"
    ? (tableRules.sort = "-" + column.prop)
    : (tableRules.sort = "");
};

// lưu tìm kiếm, sắp xếp khi reload trang web
MethodService.hashUrl = (routeQuery, tableRules) => {
  if (routeQuery.limit) {
    tableRules.limit = parseInt(routeQuery.limit);
  }
  if (routeQuery.page) {
    tableRules.page = parseInt(routeQuery.page);
  }
  if (routeQuery.limit && routeQuery.page) {
    tableRules.offset = (tableRules.page - 1) * tableRules.limit;
  }
  if (routeQuery.sort) {
    tableRules.sort = routeQuery.sort;
    tableRules.defaultSort[0] = tableRules.sort;
    tableRules.sort.indexOf("-") != -1
      ? (tableRules.defaultSort[1] = "descending")
      : (tableRules.defaultSort[1] = "ascending");
  }
  if (routeQuery.filters) {
    tableRules.filters = routeQuery.filters;
    // string to object
    tableRules.dataSearch.value = MethodService.stringToObject(
      tableRules.filters
    );
  }
  routeQuery.showFormSearch == "true"
    ? (tableRules.showFormSearch = true)
    : (tableRules.showFormSearch = false);
};
MethodService.renderStatus = (trang_thai) => {
  if (!trang_thai) return "Chưa thanh toán";
  if (trang_thai === "chua_thanh_toan") return "Chưa thanh toán";
  if (trang_thai === "cho_thanh_toan") return "Chờ thanh toán";
  if (trang_thai === "da_thanh_toan") return "Đã thanh toán";
  if (trang_thai === "huy") return "Hủy";
  if (trang_thai === "dang_san_xuat") return "Đang sản xuất";
  if (trang_thai === "dang_giao_hang") return "Đang giao hàng";
  if (trang_thai === "da_giao_hang") return "Đã giao hàng";
  if (trang_thai === "hoan_tra") return "Hoàn trả";
  if (trang_thai === "hoan_thanh") return "Hoàn thành";
  if (trang_thai === "dang_hoat_dong") return "Đang hoạt động";
  if (trang_thai === "sap_het_han") return "Sắp hết hạn";
  if (trang_thai === "cho_gia_han") return "Chờ gia hạn";
};
MethodService.formatBytes = (bytes, decimals = 2) => {
  if (!+bytes) return "0 Bytes";

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ["Bytes", "Kb", "Mb", "Gb", "Tb", "Pb", "Eb", "Zb", "Yb"];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
};
MethodService.encodeHtml = (string) => {
  if (string === undefined || string === null || string == "") return "";
  const type = typeof string;
  if (type === "boolean" || type === "number") return string.toString();
  const str = type === "string" ? string : string.toString();
  return str.replace(/[&<>'" ]/g, (c) => {
    if (c === "&") return "&amp;";
    if (c === "<") return "&lt;";
    if (c === ">") return "&gt;";
    if (c === '"') return "&quot;";
    if (c === "'") return "&apos;";
    if (c === " ") return "&nbsp;";
    return c;
  });
};
export default MethodService;
